exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buildPortfolio__heading{text-transform:uppercase}.buildPortfolio__heading>ul{display:-ms-flexbox;display:flex;-ms-flex-pack:space-evenly;justify-content:space-evenly}.buildPortfolio__heading>ul a{color:#cccccc;font-size:12px;font-weight:bold;-webkit-text-stroke-color:#aaaaaa;-webkit-text-stroke-width:0.5px}.buildPortfolio__heading .disabled{cursor:default;pointer-events:none}.buildPortfolio__heading .nav-tabs>li.active>a,.buildPortfolio__heading .nav-tabs>li.active>a:hover{-webkit-transition:all 0.2s;-o-transition:all 0.2s;transition:all 0.2s;color:#252474 !important;border-bottom:none !important;border-top:3px solid #252474 !important;border-radius:unset;-webkit-text-stroke-color:none;-webkit-text-stroke-width:0}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/common/nav/Nav.style.scss
// module id = 1597
// module chunks = 0